import React from 'react'
import PropTypes from 'prop-types'
import styles from './callUs.module.scss'
import { SitePhone } from 'common/sitePhone'

const CallUs = ({ className = '', ...rest }) => {
  return (
    <div className={`${styles.callUs} ${className}`} {...rest}>
      <p className={styles.callUs__message}>
        Call Free to Learn More and Book <SitePhone className={styles.callUs__phone} />
      </p>
    </div>
  )
}

CallUs.propTypes = {
  className: PropTypes.string,
  showIcon: PropTypes.bool,
}

export { CallUs }
